import { Platform } from "./../models/platform";
import { Store, StorePayload } from "models/store";
import axiosClient, { axiosClientPyhton } from "./axiosClient";

const storeApi = {
  getStoreList(data: StorePayload): Promise<Store> {
  const url = `/store/getStores?brandId=${data?.brandId || ""}&location_id=${
    data?.location_id || ""
  }&search=${data?.search || ""}&limit=${data?.limit || ""}&page=${
    data?.page || ""
  }&sortType=${data?.sortType || ""}&sortName=${data?.sortName || ""}`;
  
  return axiosClient.get(url);
},

  getStoresByBrandOrLocation(params: { brandId: string; locationId?: string }): Promise<any> {
    const { brandId, locationId = "" } = params;
    const url = `/store/getStoresByBrandOrLocation?brandId=${brandId}${locationId ? `&locationId=${locationId}` : ""}`;
    return axiosClient.get(url);
  },

  getStoreDetails(data: StorePayload): Promise<Store> {
    const url = `/store/getStores?_id=${data?.storeId || ""}`;
    return axiosClient.get(url);
  },

  getPlatformList(data: StorePayload): Promise<Platform> {
    const url = `/store/getStorePlatform?disablePagination=${
      data.disablePagination || ""
    }
    `;
    return axiosClient.get(url);
  },

  getBrandDataById(data: StorePayload): Promise<Store> {
    const url = `/brand/getBrandDetail?_id=${data?.brandId || ""}`;
    return axiosClient.get(url);
  },

  getStoreCharges(data: StorePayload): Promise<Store> {
    const url = `/charge/getCharges?brandId=${data.brandId}`;
    return axiosClient.get(url);
  },

  getStoreTaxes(data: StorePayload): Promise<Store> {
    const url = `/tax/getTaxes?brandId=${data.brandId}`;
    return axiosClient.get(url);
  },

  getStoreKot(data: StorePayload): Promise<Store> {
    const url = `/store/getAdminCode?storeId=${data.storeId}`;
    return axiosClient.get(url);
  },

  getStoreMenu(data: StorePayload): Promise<Store> {
    const url = `/api/addtostore`;
    return axiosClientPyhton.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  addOrUpdateStore(data: StorePayload): Promise<Store> {
    const url = `/store/addUpdateStore`;
    const brandKey =
      sessionStorage.getItem("key") ||
      data.storeData?.brandId ||
      data.brandId ||
      "";
    return axiosClient.put(url, data.storeData || data, {
      headers: { brandid: brandKey },
    });
  },

  uploadStoreImage(data: StorePayload): Promise<Store> {
    const url = `/stores/uploadStoreImage`;
    const brandKey =
      sessionStorage.getItem("key") ||
      data.storeData?.brandId ||
      data.brandId ||
      "";
    return axiosClient.post(url, data.storeData || data, {
      headers: { brandid: brandKey },
    });
  },

  placeTestOrder(data: StorePayload): Promise<any> {
    const url = `/store/placeTestOrder`;
    return axiosClient.post(url, { storeId: data.storeId }, {
      headers: {
        "X_sahl_Super": "brand9876543210",
      }
    });
  },

  getIntegration(data: StorePayload): Promise<Store> {
    const url = `/integration/getIntegrations`;
    return axiosClient.get(url);
  },

  getRoleOrders(): Promise<any> {
    const url = `/roleModuleManage/get-all`;
    return axiosClient.get(url);
  },

  getConstantsType(): Promise<any> {
    const url = `/configurationEnum/getConstantsType`;
    return axiosClient.get(url);
  },
};

export default storeApi;
